import * as React from 'react';
import { SvgComponentProps, Svg } from './svg-component';

export const ChevronIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 13} height={size || 8} viewBox="0 0 13 8" fill="none" {...rest}>
        <path
            d="M6.684 7.208c.17 0 .341-.068.458-.198l5.29-5.421a.6.6 0 0 0 .185-.438.613.613 0 0 0-.622-.629.65.65 0 0 0-.444.178L6.684 5.677 1.81.7a.62.62 0 0 0-.445-.178.613.613 0 0 0-.622.63c0 .17.069.32.185.444l5.29 5.414q.197.197.466.198Z"
            fill="currentColor"
        />
    </Svg>
);
